var _rect, _g, _rect2, _g2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 40,
    viewBox: "0 0 64 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4945_11428",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.9434,
    width: 14.1155,
    height: 42.3464,
    rx: 7.05773,
    transform: "rotate(45 29.9434 0)",
    fill: "url(#paint0_linear_4945_11428)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4945_11428)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30.1426,
    y: -0.659058,
    width: 15.8856,
    height: 46.5292,
    rx: 7.94278,
    transform: "rotate(45 30.1426 -0.659058)",
    fill: "url(#paint1_linear_4945_11428)"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 29.4531,
    width: 14.9103,
    height: 24.8087,
    rx: 7.45517,
    transform: "rotate(45 29.4531 0)",
    fill: "url(#paint2_linear_4945_11428)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4945_11428",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 2,
    width: 35,
    height: 36
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.6572,
    width: 14.1155,
    height: 42.3464,
    rx: 7.05773,
    transform: "rotate(45 53.6572 0)",
    fill: "url(#paint3_linear_4945_11428)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4945_11428)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.5078,
    y: -0.659058,
    width: 14.6429,
    height: 43.9286,
    rx: 7.32143,
    transform: "rotate(45 54.5078 -0.659058)",
    fill: "url(#paint4_linear_4945_11428)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.876,
    y: 0.4328,
    width: 14.1155,
    height: 27.0626,
    rx: 7.05773,
    transform: "rotate(45 53.876 0.4328)",
    fill: "url(#paint5_linear_4945_11428)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1006,
    y: 22.3965,
    width: 12.4475,
    height: 12.4475,
    rx: 6.22377,
    transform: "rotate(45 55.1006 22.3965)",
    fill: "url(#paint6_linear_4945_11428)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4945_11428",
    x1: 37.0011,
    y1: 0,
    x2: 37.0011,
    y2: 42.3464,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4945_11428",
    x1: 38.0854,
    y1: -0.659058,
    x2: 38.0854,
    y2: 45.8701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4945_11428",
    x1: 36.9083,
    y1: 0,
    x2: 36.9083,
    y2: 24.8087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE2A86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E2E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4945_11428",
    x1: 60.6308,
    y1: 41.7343,
    x2: 61.6955,
    y2: 1.01129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED52E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E98FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4945_11428",
    x1: 61.742,
    y1: 42.6346,
    x2: 62.8464,
    y2: 0.390021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED52E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E98FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4945_11428",
    x1: 60.8496,
    y1: 27.1043,
    x2: 61.2846,
    y2: 1.06858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED52E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E98FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4945_11428",
    x1: 61.3244,
    y1: 22.3965,
    x2: 61.3244,
    y2: 34.8441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CCF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.55e41904cc8a1b8fc07bc9652c8c9c01.svg";
export { ForwardRef as ReactComponent };